import React, { Component } from "react";
import Select from "react-select";
import { colourStyles } from "../../common/scripts/react-select-styles";

export default class FormatoDireccion extends React.PureComponent {
  constructor(props) {
    super(props);

    this.estado = {
      esUrbana: true,
      direccion: null,
      tiposDevia: tipoVia,
      tipoVia: { value: "" },
      numeroPrincipal: "",
      sufijo: { value: "" },
      subSufijo: { value: "" },
      numeroSecundario: "",
      sufijoNumeroSecundario: { value: "" },
      subSufijoNumeroSecundario: { value: "" },
      numeroComplementario: "",
      barrio: "",
      tipoInmueble: { value: "" },
      detalleTipoInmueble: "",
      bloqueInterior: { value: "" },
      detalleBloqueInterior: "",
      direccionRural: "",
      observacionesDireccionRual: "",
      disabled: true,
    };

    this.state = sessionStorage.getItem("direccionFormCovid")
      ? JSON.parse(sessionStorage.getItem("direccionFormCovid"))
      : this.estado;
    this.submitDireccion = this.submitDireccion.bind(this);
    this.handleTituloDireccion = this.handleTituloDireccion.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  dataOrganized() {
    let data = {
      tipoViaText: this.state.tipoVia
        ? this.state.tipoVia.value
          ? this.state.tipoVia.value
          : ""
        : "",
      sufijoText: this.state.sufijo
        ? this.state.sufijo.value
          ? this.state.sufijo.value
          : ""
        : "",
      subSufijoText: this.state.subSufijo
        ? this.state.subSufijo.value
          ? this.state.subSufijo.value
          : ""
        : "",
      sufijoNumeroSecundarioText: this.state.sufijoNumeroSecundario
        ? this.state.sufijoNumeroSecundario.value
          ? this.state.sufijoNumeroSecundario.value
          : ""
        : "",
      subSufijoNumeroSecundarioText: this.state.subSufijoNumeroSecundario
        ? this.state.subSufijoNumeroSecundario.value
          ? this.state.subSufijoNumeroSecundario.value
          : ""
        : "",
      numeroComplementarioText: this.state.numeroComplementario
        ? this.state.numeroComplementario
        : "",
      tipoInmuebleText: this.state.tipoInmueble
        ? this.state.tipoInmueble.value
          ? this.state.tipoInmueble.value
          : ""
        : "",
      bloqueInteriorText: this.state.bloqueInterior
        ? this.state.bloqueInterior.value
          ? this.state.bloqueInterior.value
          : ""
        : "",
    };
    return data;
  }

  validateForm() {
    let data = this.dataOrganized();
    data.tipoViaText == "" ||
    this.state.numeroPrincipal == "" ||
    this.state.numeroSecundario == "" ||
    this.state.numeroComplementario == "" ||
    this.state.barrio === ""
      ? this.setState({ disabled: true })
      : this.setState({ disabled: false });
  }

  submitDireccion(event) {
    event.preventDefault();
    let direccion;
    let observaciones;
    let barrio;
    if (this.state.esUrbana) {
      let data = this.dataOrganized();
      direccion = `${data.tipoViaText} ${this.state.numeroPrincipal} ${data.sufijoText} ${data.subSufijoText} # ${this.state.numeroSecundario} ${data.sufijoNumeroSecundarioText} ${data.subSufijoNumeroSecundarioText} ${data.numeroComplementarioText} ${data.bloqueInteriorText} ${this.state.detalleBloqueInterior} ${data.tipoInmuebleText} ${this.state.detalleTipoInmueble}`;
      barrio = this.state.barrio;
    } else {
      direccion = this.state.direccionRural;
      observaciones = this.state.observacionesDireccionRual;
    }
    direccion = direccion === "    #        " ? "" : direccion;
    this.props.direccion(direccion, barrio, observaciones);
    sessionStorage.setItem("direccionFormCovid", JSON.stringify(this.state));
  }

  handleTituloDireccion() {
    let data = this.dataOrganized();
    let direccion = `${data.tipoViaText} ${this.state.numeroPrincipal} ${data.sufijoText} ${data.subSufijoText} # ${this.state.numeroSecundario} ${data.sufijoNumeroSecundarioText} ${data.subSufijoNumeroSecundarioText} ${data.numeroComplementarioText} ${data.bloqueInteriorText} ${this.state.detalleBloqueInterior} ${data.tipoInmuebleText} ${this.state.detalleTipoInmueble}`;
    return direccion;
  }

  render() {
    let regexAlfaNum = /[^a-z A-Z0-9]+/g;
    return (
      <section className="">
        <div className="cotizar-form-controls  btn-terminosCondiciones">
          <button
            onClick={() => this.setState({ esUrbana: true })}
            className={`cotizar-form-controls-action  ${
              this.state.esUrbana ? " active" : null
            }`}
            style={{ width: "70px" }}
          >
            Urbana
          </button>
          <button
            onClick={() => this.setState({ esUrbana: false })}
            className={`cotizar-form-controls-action ${
              !this.state.esUrbana ? " active" : null
            }`}
            style={{ width: "70px" }}
          >
            {" "}
            Rural
          </button>
        </div>
        {this.state.esUrbana ? (
          <form
            className="row formularioSolicitud noPadding"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="row col-sm-12">
              <h3 className="col-sm-12">{this.handleTituloDireccion()}</h3>
            </div>

            <div className="row col-sm-12 form-group">
              <div className="col-sm-12">
                <label>Tipo de via*</label>
                <Select
                  placeholder={"Seleccione una opción"}
                  value={this.state.tipoVia}
                  onChange={(e) => {
                    this.setState({ tipoVia: e });
                    this.validateForm();
                  }}
                  options={this.state.tiposDevia}
                  isClearable={true}
                  styles={colourStyles}
                />
              </div>
            </div>

            <div className="row col-sm-12 form-group">
              <div className="col-sm-4">
                <label>Nº principal*</label>
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={"form-control formularioSolicitud--input"}
                  onChange={(e) => {
                    this.setState({
                      numeroPrincipal: e.target.value.replace(regexAlfaNum, ""),
                    });
                    this.validateForm();
                  }}
                  value={this.state.numeroPrincipal}
                  maxLength={20}
                />
              </div>

              <div className="col-sm-4">
                <label>Sufijo</label>
                <Select
                  placeholder={"..."}
                  value={this.state.sufijo}
                  onChange={(e) => this.setState({ sufijo: e })}
                  isClearable={true}
                  options={sufijo}
                  styles={colourStyles}
                />
              </div>

              <div className="col-sm-4">
                <label>Sub-sufijo</label>
                <Select
                  placeholder={"..."}
                  value={this.state.subSufijo}
                  onChange={(e) => this.setState({ subSufijo: e })}
                  isClearable={true}
                  options={subSufijo}
                  styles={colourStyles}
                />
              </div>
            </div>

            <div className="row col-sm-12 form-group">
              <div className="col-sm-3">
                <label>N° secundario*</label>
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={"form-control formularioSolicitud--input"}
                  onChange={(e) => {
                    this.setState({
                      numeroSecundario: e.target.value.replace(
                        regexAlfaNum,
                        ""
                      ),
                    });
                    this.validateForm();
                  }}
                  value={this.state.numeroSecundario}
                  maxLength={20}
                />
              </div>

              <div className="col-sm-3">
                <label>Sufijo</label>
                <Select
                  placeholder={"..."}
                  value={this.state.sufijoNumeroSecundario}
                  onChange={(e) => this.setState({ sufijoNumeroSecundario: e })}
                  isClearable={true}
                  options={sufijo}
                  styles={colourStyles}
                />
              </div>

              <div className="col-sm-3">
                <label>Sub-sufijo</label>
                <Select
                  placeholder={"..."}
                  value={this.state.subSufijoNumeroSecundario}
                  onChange={(e) =>
                    this.setState({ subSufijoNumeroSecundario: e })
                  }
                  isClearable={true}
                  options={subSufijo}
                  styles={colourStyles}
                />
              </div>

              <div className="col-sm-3">
                <label>N° complementario*</label>
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={"form-control formularioSolicitud--input"}
                  onChange={(e) => {
                    this.setState({
                      numeroComplementario: e.target.value.replace(
                        regexAlfaNum,
                        ""
                      ),
                    });
                    this.validateForm();
                  }}
                  value={this.state.numeroComplementario}
                  maxLength={20}
                />
              </div>
            </div>

            <div className="row col-sm-12 form-group">
              <div className="col-sm-12">
                <label>Barrio*</label>
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={"form-control formularioSolicitud--input"}
                  onChange={(e) => {
                    this.setState({ barrio: e.target.value });
                    this.validateForm();
                  }}
                  value={this.state.barrio}
                  maxLength={30}
                />
              </div>
            </div>

            <div className="row col-sm-12 form-group">
              <div className="col-sm-8">
                <label>Bloque o Interior</label>
                <Select
                  placeholder={"Selecciona"}
                  value={this.state.bloqueInterior}
                  onChange={(e) => this.setState({ bloqueInterior: e })}
                  isClearable={true}
                  options={bloqueInterior}
                  styles={colourStyles}
                />
              </div>
              <div className="col-sm-4">
                <label>Detalles</label>
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={"form-control formularioSolicitud--input"}
                  onChange={(e) =>
                    this.setState({
                      detalleBloqueInterior: e.target.value.replace(
                        regexAlfaNum,
                        ""
                      ),
                    })
                  }
                  value={this.state.detalleBloqueInterior}
                  maxLength={50}
                />
              </div>
            </div>

            <div className="row col-sm-12 form-group">
              <div className="col-sm-8">
                <label>Tipo de inmueble</label>
                <Select
                  placeholder={"Selecciona"}
                  value={this.state.tipoInmueble}
                  onChange={(e) => this.setState({ tipoInmueble: e })}
                  isClearable={true}
                  options={tipoInmueble}
                  styles={colourStyles}
                />
              </div>
              <div className="col-sm-4">
                <label>Detalles</label>
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={"form-control formularioSolicitud--input"}
                  onChange={(e) =>
                    this.setState({
                      detalleTipoInmueble: e.target.value.replace(
                        regexAlfaNum,
                        ""
                      ),
                    })
                  }
                  value={this.state.detalleTipoInmueble}
                  maxLength={50}
                />
              </div>
            </div>

            <div className="col-sm-6 form-group">
              <button
                disabled={
                  this.dataOrganized().tipoViaText == "" ||
                  this.state.numeroPrincipal == "" ||
                  this.state.numeroSecundario == "" ||
                  this.state.numeroComplementario == "" ||
                  this.state.barrio == ""
                    ? true
                    : false
                }
                onClick={(e) => this.submitDireccion(e)}
                className={"btn btn-default btn-no btn-right"}
              >
                Confirmar Dirección
              </button>
            </div>

            <div className="col-sm-6 form-group">
              <button
                type="button"
                onClick={() => this.setState(this.estado)}
                className={"btn btn-primary btn-no btn-right"}
              >
                Borrar Dirección
              </button>
            </div>
          </form>
        ) : (
          <form
            className="row formularioSolicitud noPadding"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="row col-sm-12">
              <h3 className="col-sm-12">{this.state.direccionRural}</h3>
            </div>

            <div className="col-sm-12 form-group">
              <label>Direccion Rural</label>
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={"form-control formularioSolicitud--input"}
                onChange={(e) => {
                  this.setState({ direccionRural: e.target.value });
                }}
                value={this.state.direccionRural}
              />
            </div>

            <div className="col-sm-12 form-group">
              <label>Detalles Ubicación</label>
              <textarea
                className={"form-control formularioSolicitud--input"}
                style={{ width: "100%" }}
                onChange={(e) => {
                  this.setState({ observacionesDireccionRual: e.target.value });
                }}
                value={this.state.observacionesDireccionRual}
              />
            </div>

            <div className="col-sm-6 form-group">
              <button
                onClick={(e) => this.submitDireccion(e)}
                className={"btn btn-default btn-no btn-right"}
              >
                Confirmar Dirección
              </button>
            </div>

            <div className="col-sm-6 form-group">
              <button
                onClick={() => this.setState(this.estado)}
                className={"btn btn-primary btn-no btn-right"}
              >
                Borrar Dirección
              </button>
            </div>
          </form>
        )}
      </section>
    );
  }
}
